<template>
	<div class="hotelsws">
		<div class="infinite-loading-containerss" >
			<i class="loading-defaultss"></i>
		</div>
	
	</div>
</template>
<script>

	export default{

	 	data(){
			return {
				isBookSuccess:false,
				OrderNO:'',
				isSubmited:true,
				flag:false,
				OrderTypeId:1,
				HAPI:this.Api.getPayParam,
				OAPI:this.Api.getOnlinePayParam,
			}
	 	},
	
	 	methods:{
			payByWX(orderNO){
				var that=this; 
				var myAPI = that.flag?that.HAPI:that.OAPI
				that.isSubmited=false;
			 	var param={
					orderNO:orderNO,
					isMP:false,
				}
				this.getRequest({
						url:myAPI,
						params:param
					}).then(res => {
					   that.dao.set('thisBookingOrderNO','');
					   if(res&&res.IsSuccess){
					   	    var config=res.Result;
					   	    onBridgeReady(config,that);
					   	    return;
						    var location=window.location.href;
						    var protocol = window.location.protocol + '//';
					   	    window.location.href=protocol+that.Api.domain+'/wxPayProxy.html?appId='+config.Result.AppID+'&timeStamp='+config.Result.TimeStamp+'&nonceStr='+config.Result.Nonce+'&package='+config.Result.Package+'&signType='+config.Result.SignType+'&paySign='+config.Result.Sign+'&OrderNO='+that.OrderNO+'&url='+location;
					   }else{
					   	that.error({title:'提示',content:res.Msg});
							that.$router.replace({path: '/BookDetails', query: {OrderNO:that.OrderNO,OrderTypeId:that.OrderTypeId,source:true}});
					   }
				});
			},
			getWebPayUrl(orderNO,pd,QGId){
				var that=this; 
				that.isSubmited=false;
			 	var param={
					QGId:QGId,
					PDS:pd,
					OrderNO:orderNO,
					IsMP:false,
				}
				this.postRequest({
						url:this.Api.getWebPayUrl,
						params:param
					}).then(res => {
					   if(res&&res.IsSuccess){
							window.location.href = res.Result
							
					   }else{
					   	that.error({title:'提示',content:res.Msg||'支付页面生成失败！'});
							this.$router.replace({path: '/BookDetails', query: {OrderNO:that.OrderNO,OrderTypeId:that.OrderTypeId,source:true}});
					   }
				});
			},
			getPayUrl(orderNO){
				var that=this; 
				that.isSubmited=false;
			 	var param={
					OrderNO:orderNO,
					IsMP:false,
				}
				var myApi = ''
				if(orderNO.indexOf('CN')>-1){
					myApi = that.Api.getPayUrl
				}else {
					myApi = that.Api.getPackagePayUrl
				}
				this.getRequest({
						url:myApi,
						params:param
					}).then(res => {
					   if(res&&res.IsSuccess){
							window.location.href = res.Result
					   }else{
					   	that.error({title:'提示',content:res.Msg||'支付页面生成失败！'});
							if(orderNO.indexOf('CN')>-1){
								this.$router.replace({path: '/BookDetails', query: {OrderNO:that.OrderNO,OrderTypeId:0,source:true}});
							}else {
								this.$router.replace({path: '/BookDetails', query: {OrderNO:that.OrderNO,OrderTypeId:1,source:true}});
							}
							
					   }
				});
			},
	 	},
	 	mounted(){
			var isWx = false
			var GDflag = this.dao.get('GDflag')||''
			var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
          isWx = true
					console.log('isWx')          
      }
			if(this.dao.get('thisBookingOrderNO')||this.$route.query.orderNO){
				this.OrderNO=this.dao.get('thisBookingOrderNO');
				if(this.$route.query.isReserve){
					var pd = this.$route.query.pd
					var orderNO = this.$route.query.orderNO
					var QGId = this.$route.query.id
					this.OrderTypeId = 1
					this.getWebPayUrl(orderNO,pd,QGId)
				}else if(!isWx||GDflag){
					this.getPayUrl(this.OrderNO)
				}else{
					if(this.$route.query.flag){
						this.flag = this.$route.query.flag
						this.OrderTypeId = this.flag?0:1
					}
					this.payByWX(this.OrderNO);
				}
			}else{
				window.history.go(-1)
			}
	 	}
	}
	function onBridgeReady(config,that){
	
	    WeixinJSBridge.invoke(
	       'getBrandWCPayRequest', {
	           "appId":config.AppID,     //公众号名称，由商户传入     
	           "timeStamp":String(config.TimeStamp), //时间戳，自1970年以来的秒数     
	           "nonceStr":config.Nonce, //随机串     
	           "package":config.Package,     
	           "signType":config.SignType, //微信签名方式：     
	           "paySign":config.Sign//微信签名 
	       },
	       function(res){
	       		setTimeout(()=>{
							that.$router.push({path: '/BookDetails', query: {OrderNO:that.OrderNO,OrderTypeId:that.OrderTypeId,source:true}});
						},5000)
	      }
	   ); 
	}

</script>
<style scoped>
.infinite-loading-containerss {
    display: inline-block;
    margin: 15px 0;
    width: 28px;
    height: 28px;
    font-size: 28px;
    line-height: 28px;
    border-radius: 50%;
    border:1px solid #999;
    -webkit-animation:ease loading-rotatings 1.5s infinite;
    animation: ease loading-rotatings 1.5s infinite;
    position: relative;
    left: 50%;
    margin-left: -14px;
}
.loading-defaultss{
    position: relative;
}
.loading-defaultss:before{
   
    content: '';
    position: absolute;
    display: block;
    top: 0;
    left: 50%;
	margin-top: -3px;
    margin-left: 11px;
    width: 6px;
    height: 6px;
    background-color: #999;
    border-radius: 50%;
}
.hotelsws{
    padding-top: 50%;
}
 @-webkit-keyframes loading-rotatings{
  0%{
    transform: rotate(0);
  }
  100%{
    transform: rotate(360deg);
  }
}
@keyframes loading-rotatings{
  0%{
    transform: rotate(0);
  }
  100%{
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/book/wxPay.vue